import Vue from "vue";
import VueScrollReveal from "vue-scroll-reveal";

Vue.use(VueScrollReveal, {
  class: "v-scroll-reveal",
  origin: "top",
  distance: "40px",
  duration: 1000,
});
